'use client';

import './styles/@theme';

type DotsStepperProps = {
    currentStep: number;
    totalNumberOfSteps: number;
};

export const DotsStepper = ({ currentStep, totalNumberOfSteps }: DotsStepperProps) => {
    const spawnDots = () => {
        const dots = [];
        for (let i = 0; i < totalNumberOfSteps; i++) {
            dots.push(<div key={i} className={`dot-step-${i + 1 === currentStep ? 'active' : 'inactive'}`} />);
        }
        return dots;
    };

    return <div className="dots-stepper-wrapper">{spawnDots()}</div>;
};
